<template>
	<b-card>
		<div class="hidden-print">
			<b-row style="margin-top: 10px; margin-bottom: 10px">
				<b-col>
					<date-picker v-model="fromDate" lang="ru" style="width: 100%"
						:placeholder="$t('certificate.fromDate')" valueType="format" format="DD-MM-YYYY" />
				</b-col>
				<b-col>
					<date-picker v-model="toDate" lang="ru" style="width: 100%" :placeholder="$t('certificate.toDate')"
						value-type="format" format="DD-MM-YYYY" />
				</b-col>
				<b-col>
					<b-button @click="getItems" :disabled="loading" variant="dark" class="fa fa-search mr-2 ml-2" />
				</b-col>
			</b-row>
			<hr class="mt-1">
		</div>
		<b-card-body class="marginPage">
			<b-row>
				<b-col cols="3">
					<div style="font-size: 10px">DutyFree International</div>
				</b-col>
				<b-col cols="6" class="text-center">
					<h6><b>{{ $t("Commodity_report_for_the_period") }}* {{ $t("c") }} {{ fromDate ? fromDate : '________' }}
							{{ $t("po") }} {{ toDate ? toDate : '________' }}</b></h6>
				</b-col>
			</b-row>
			<b-row class="mt-4">
				<b-col>
					<table class="table-bordered table table-striped table-hover" v-if="items.length > 0">
						<thead>
							<tr>
								<th class="text-center" v-for="item in items">{{ item.department }}</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td></td>
							</tr>
						</tbody>
					</table>
				</b-col>
			</b-row>
		</b-card-body>
	</b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import { BTable, VBTable } from "bootstrap-vue";
import { BOverlay } from 'bootstrapVue2';
import UsersService from "../../../services/users.sevice";
import { TokenService } from "../../../services/storage.service";
import ReportService from "./report.service";

export default {
	name: "Товарный отчет за период",
	components: { Multiselect, BTable, VBTable, BOverlay },
	data() {
		return {
			items: [],
			fromDate: null,
			toDate: null,
			departments: [],
			departmentId: null,
			departmentName: '',
			allDep: true,
			loading: false,
			depIds: [],
			depNames: []
		};
	},
	methods: {
		async getDeps() {
			await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
				this.departments = response.data.permittedDepartments
				if (this.departments.length > 0) {
					this.depIds = []
					this.departments.forEach(r => {
						this.depIds.push(r.id)
					})
				}
			})
		},
		excelExport1(tableID, filename = '') {
			var uri = 'data:application/vnd.ms-excel;base64,',
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
				base64 = function (s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				},
				format = function (s, c) {
					return s.replace(/{(\w+)}/g, function (m, p) {
						return c[p];
					})
				}
			var toExcel = document.getElementById(tableID).innerHTML;
			var ctx = {
				worksheet: name || '',
				table: toExcel
			};
			var link = document.createElement("a");
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx))
			link.click();
		},
		print() {
			window.print();
		},
		getItems() {
			this.loading = true
			this.items = []
			if (this.depIds.length > 0 && this.fromDate && this.toDate) {
				let data = {
					startDate: this.fromDate,
					endDate: this.toDate,
					deps: this.depIds
				}
				ReportService.getReportItems2(data).then(res => {
					this.items = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				this.loading = false
				this.$vs.notify({
					text: "Выберите Подразделение с периодом",
					color: "warning",
					icon: "close",
					position: "top-right"
				});
				return 0;
			}
		}
	},
	created() {
		this.getDeps();
	},
	computed: {
		computedJsonToExcel() {
			let visibleFields = {};
			this.fields.forEach(t => {
				if (t.visible === true) {
					visibleFields[t.label] = t.key;
				}
			})
			return visibleFields;
		},
		computedFields() {
			let tmp = []
			this.fields.forEach(t => {
				if (t.visible)
					tmp.push(t)
			})
			return tmp
		},

		depName() {
			this.departments.forEach(dep => {
				if (dep.id === this.departmentId) {
					this.departmentName = dep.name
				}
			})
			return this.departmentName
		},
		sumSaleInEur() {
			let sum = 0
			this.items.forEach(t => {
				if (t.saleInEur)
					sum = sum + parseFloat(t.saleInEur.toFixed(2))
			})
			return sum;
		},
		sumSaleInUzs() {
			let sum = 0
			this.items.forEach(t => {
				if (t.saleInUzs)
					sum = sum + parseFloat(t.saleInUzs.toFixed(2))
			})
			return sum;
		},
		sumSumInEur() {
			let sum = 0
			this.items.forEach(t => {
				if (t.sumInEur)
					sum = sum + parseFloat(t.sumInEur.toFixed(2))
			})
			return sum;
		},
		sumSumInUzs() {
			let sum = 0
			this.items.forEach(t => {
				if (t.sumInUzs) {
					sum = sum + parseFloat(t.sumInUzs.toFixed(2))
				}
			})
			return sum;
		}
	},
	watch: {
		'departmentId': {
			handler(newValue) {
				this.depIds = []
				this.depNames = []
				newValue.forEach(res => {
					this.depIds.push(res.id)
					this.depNames.push(res.name)
				})
			}
		},
		'allDep': {
			handler(res) {

			}
		}
	}
}
</script>

<style scoped>
@page {
	margin: 1cm;
}

@media print {
	.hidden-print {
		display: none;
	}

	.marginPage {
		margin: 0 30px 0 40px;
	}
}
</style>
